/**
 * Redirect mappings provided by SEO sheet (RedirectionUrls.xlsx).
 * Category legacy paths redirect to the on-site /marketplace page (SPA + nginx/_redirects).
 *
 * Path redirects here are the CRA/SPA fallback. Production HTTP 301s live in
 * nginx.conf and public/_redirects. Keep all three in sync.
 */
import { buildLegacyCategoryRedirects } from '../utils/exploreCategoryLinks';

const CATEGORY_LEGACY_REDIRECTS = buildLegacyCategoryRedirects();

export const LEGACY_HOME_QUERY_REDIRECTS = [
  { param: 'trk', value: 'public_post-text' },
  { param: 'trk', value: 'test' },
  { param: 'elementor_library', value: 'default-kit' },
];

export function shouldRedirectLegacyHomeQuery(searchParams) {
  if (!searchParams) return false;
  return LEGACY_HOME_QUERY_REDIRECTS.some(
    ({ param, value }) => searchParams.get(param) === value
  );
}

export const LEGACY_LANDING_REDIRECTS = [
  { from: '/blogpage', to: '/blog' },
  { from: '/lifestyle', to: '/marketplace' },
  { from: '/is-the-barter-system-legal-in-india', to: '/blog/is-the-barter-system-legal-in-india' },
  { from: '/blogpage/is-the-barter-system-legal-in-india', to: '/blog/is-the-barter-system-legal-in-india' },
  { from: '/blogpage/barter-trade-companies', to: '/blog/barter-trade-companies' },
  { from: '/barter-trade-companies', to: '/blog/barter-trade-companies' },
  { from: '/blogpage/the-benefits-of-barter-service-for-small-businesses', to: '/blog/the-benefits-of-barter-service-for-small-businesses' },
  { from: '/the-benefits-of-barter-service-for-small-businesses', to: '/blog/the-benefits-of-barter-service-for-small-businesses' },
  { from: '/blogpage/difference-between-barter-exchange-and-money-exchange', to: '/blog/difference-between-barter-exchange-and-money-exchange' },
  { from: '/difference-between-barter-exchange-and-money-exchange', to: '/blog/difference-between-barter-exchange-and-money-exchange' },
  { from: '/blogpage/exploring-the-online-bartering-platform-market-trends-benefits-and-top-platforms', to: '/blog/exploring-the-online-bartering-platform-market-trends-benefits-and-top-platforms' },
  { from: '/exploring-the-online-bartering-platform-market-trends-benefits-and-top-platforms', to: '/blog/exploring-the-online-bartering-platform-market-trends-benefits-and-top-platforms' },
  { from: '/blogpage/barters-digital-evolution-from-traditional-to-modern', to: '/blog/barters-digital-evolution-from-traditional-to-modern' },
  { from: '/barters-digital-evolution-from-traditional-to-modern', to: '/blog/barters-digital-evolution-from-traditional-to-modern' },
  { from: '/category/trending/', to: '/marketplace' },
  { from: '/the-role-of-trust-in-barter-deals', to: '/blog/the-role-of-trust-in-barter-deals' },
  { from: '/blogpage/the-role-of-trust-in-barter-deals', to: '/blog/the-role-of-trust-in-barter-deals' },
  { from: '/blogpage/types-of-b2b-marketplaces', to: '/blog/types-of-b2b-marketplaces' },
  { from: '/types-of-b2b-marketplaces', to: '/blog/types-of-b2b-marketplaces' },
  { from: '/barter-for-service-&-goods', to: '/blog/barter-for-service-and-goods' },
  { from: '/blogpage/barter-for-service-&-goods', to: '/blog/barter-for-service-and-goods' },
  { from: '/blog/barter-for-service-&-goods', to: '/blog/barter-for-service-and-goods' },
  { from: '/Address', to: '/' },
  { from: '/howitworks', to: '/' },
  { from: '/contactus', to: '/contact-us' },
  { from: '/faqs', to: '/faq' },
  { from: '/ns', to: '/' },
  { from: '/forget', to: '/' },
  { from: '/home/marketplace/category/*', to: '/marketplace' },
  { from: '/support@bxiworld.com.', to: '/contact-us' },
  { from: '/blogpage/ns', to: '/blog' },
  { from: '/advantages-and-disadvantages-of-the-barter-system-of-exchange', to: '/blog/advantages-and-disadvantages-of-the-barter-system-of-exchange' },
  { from: '/blogpage/advantages-and-disadvantages-of-the-barter-system-of-exchange', to: '/blog/advantages-and-disadvantages-of-the-barter-system-of-exchange' },
  { from: '/barter-exchange-goods-without-involving-money', to: '/blog/barter-exchange-goods-without-involving-money' },
  { from: '/blogpage/barter-exchange-goods-without-involving-money', to: '/blog/barter-exchange-goods-without-involving-money' },
  { from: '/how-does-barter-work-in-modern-india', to: '/blog/how-does-barter-work-in-modern-india' },
  { from: '/blogpage/how-does-barter-work-in-modern-india', to: '/blog/how-does-barter-work-in-modern-india' },
  { from: '/blogpage/get-work-done-without-cashflow', to: '/blog/get-work-done-without-cashflow' },
  { from: '/blogpage/how-modern-business-exchange-value', to: '/blog/how-modern-business-exchange-value' },
  { from: '/blogpage/barter-exchange-benefits-for-businesses', to: '/blog/barter-exchange-benefits-for-businesses' },
  { from: '/blogpage/barter-networks-indian-b2b-trade', to: '/blog/barter-networks-indian-b2b-trade' },
  { from: '/blogpage/enhance-your-business-potential-with-b2b-barter-marketplace-platforms', to: '/blog/enhance-your-business-potential-with-b2b-barter-marketplace-platforms' },
  { from: '/blogpage/future-of-b2b-barter-cashless-business-exchange', to: '/blog/future-of-b2b-barter-cashless-business-exchange' },
  { from: '/blogpage/how-barter-can-grow-your-business-community', to: '/blog/how-barter-can-grow-your-business-community' },
  { from: '/how-barter-can-grow-your-business-community', to: '/blog/how-barter-can-grow-your-business-community' },
  { from: '/blogpage/what-is-b2b-barter', to: '/blog/what-is-b2b-barter' },
  { from: '/what-is-b2b-barter', to: '/blog/what-is-b2b-barter' },
  { from: '/html/fmbroadcasting_3.html', to: '/' },
  { from: '/terms-conditions/', to: '/termsconditions' },
  { from: '/2021/02/', to: '/' },
  { from: '/elementor-hf/new-header/', to: '/' },
  { from: '/test/', to: '/' },
  { from: '/2017/08/', to: '/' },
  { from: '/join-today/', to: '/contact-us' },
  { from: '/feed/', to: '/blog' },
  { from: '/2018/12/26/quick-eye-makeup/', to: '/blog' },
  { from: '/elementor-hf/footer/', to: '/' },
  { from: '/2021/02/01/hello-world/', to: '/' },
  { from: '/category/before-after/', to: '/marketplace' },
  { from: '/how-it-works//1000', to: '/learnbarter' },
  { from: '/comments/feed/', to: '/blog' },
  { from: '/about//1000', to: '/about' },
  { from: '/home/feed/', to: '/' },
  { from: '/2019/01/', to: '/' },
  ...CATEGORY_LEGACY_REDIRECTS,
];
